import { API_BASE } from "@/lib/api";
import { cn } from "@/lib/utils";

// "Powered by Quantum eMotion" credit — ties the QRNG/quantum-secured story to the QeM brand.
// The white logo is served by the backend (GET /api/brand/qemotion-logo-white.png).
export function QemCredit({ className, size = 14 }) {
  return (
    <a
      href="https://quantumemotion.com"
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "inline-flex items-center gap-1.5 text-[11px] font-medium text-bloq-muted transition-opacity hover:opacity-100 opacity-75",
        className,
      )}
      data-testid="qem-credit"
      title="Entropy powered by Quantum eMotion (QeM)"
    >
      <span>Powered by</span>
      <img
        src={`${API_BASE}/brand/qemotion-logo-white.png`}
        alt="Quantum eMotion"
        style={{ height: size }}
        className="w-auto"
        data-testid="qem-logo"
      />
    </a>
  );
}
